import React from 'react';
import { CheckCircle, BoxIcon } from 'lucide-react';
interface AdvantageCardProps {
  icon?: BoxIcon;
  title: string;
  description?: string;
  variant?: 'grid' | 'list';
}
export function AdvantageCard({
  icon: Icon,
  title,
  description,
  variant = 'grid'
}: AdvantageCardProps) {
  if (variant === 'list') {
    return <div className="flex items-start p-4 bg-white rounded-lg border border-gray-100 shadow-sm" data-id="element-106">
        <CheckCircle className="w-6 h-6 text-[#C4161C] mr-4 flex-shrink-0" data-id="element-107" />
        <div data-id="element-108">
          <h4 className="font-bold text-gray-900" data-id="element-109">{title}</h4>
          {description && <p className="text-sm text-gray-600 mt-1" data-id="element-110">{description}</p>}
        </div>
      </div>;
  }
  return <div className="p-6 bg-white rounded-xl border border-gray-100 shadow-sm hover:shadow-md transition-all text-center group h-full" data-id="element-111">
      {Icon && <div className="mx-auto w-12 h-12 rounded-full bg-gray-50 flex items-center justify-center text-gray-600 mb-4 group-hover:bg-[#C4161C] group-hover:text-white transition-colors" data-id="element-112">
          <Icon className="w-6 h-6" data-id="element-113" />
        </div>}
      <h3 className="font-bold text-gray-900 mb-2" data-id="element-114">{title}</h3>
      {description && <p className="text-sm text-gray-600" data-id="element-115">{description}</p>}
    </div>;
}